import React from "react";
import { useTranslation } from "react-i18next";

const TotalQuotePrices = ({ totals = {} }) => {
  const { t } = useTranslation();
  return (
    <div className="invoice-section totals-section">
      <div className="totals-column">
        <div className="total-row">
          <span>{t("invoice.total_ht")}</span>
          <span>{(totals?.subtotal || 0).toFixed(2)} €</span>
        </div>

        <div className="total-row">
          <span>{t("invoice.reduction")}</span>
          <span>{(totals.discountAmount || 0).toFixed(2)} €</span>
        </div>

        <div className="total-row">
          <span>{t("invoice.tva")}</span>
          <span>{(totals?.tva || 0).toFixed(2)} €</span>
        </div>

        <div className="total-row total-bold">
          <span>{t("invoice.total")}</span>
          <span>{(totals?.ttc || 0).toFixed(2)} €</span>
        </div>
      </div>
    </div>
  );
};

export default TotalQuotePrices;
